import { render, staticRenderFns } from "./TabNav.vue?vue&type=template&id=66e37f00&scoped=true&web=true&"
import script from "./TabNav.vue?vue&type=script&lang=ts&"
export * from "./TabNav.vue?vue&type=script&lang=ts&"
import style0 from "./TabNav.vue?vue&type=style&index=0&id=66e37f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e37f00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})
